import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initFadeInAnimations() {
    const fadeElements = document.querySelectorAll('[data-fade-in]');
    
    fadeElements.forEach((element) => {
        const delay = parseFloat(element.dataset.delay) || 0;
        const duration = parseFloat(element.dataset.duration) || 1;
        const direction = element.dataset.direction || 'up';
        
        let fromVars = { opacity: 0 };
        
        switch (direction) {
            case 'up': fromVars.y = 50; break;
            case 'down': fromVars.y = -50; break;
            case 'left': fromVars.x = 50; break;
            case 'right': fromVars.x = -50; break;
        }
        
        gsap.set(element, fromVars);
        
        ScrollTrigger.create({
            trigger: element,
            start: "top 80%",
            once: true,
            onEnter: () => {
                gsap.to(element, {
                    opacity: 1,
                    x: 0,
                    y: 0,
                    duration: duration,
                    delay: delay,
                    ease: "power2.out"
                });
            }
        });
    });
}
